<div *ngIf="isLoading" class="d-flex justify-content-center align-items-center erg-state-fill">
</div>

<div *ngIf="!isLoading && !chapterList">
  <div class="d-flex flex-column align-items-center justify-content-center erg-state-fill">
    <i class="fa fa-lock fa-3x mb-3" aria-hidden="true"></i>
    <strong>You're not authorized to view this page. Please contact your administrator if you believe this is an
      error.</strong>
  </div>
</div>

<div class="erg-confirm-overlay" *ngIf="showConfirmDialog">
  <div class="erg-confirm-dialog">
    <div class="erg-confirm-icon">
      <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
    </div>
    <h4 class="erg-confirm-title">Unsaved Changes</h4>
    <p class="erg-confirm-message">You have unsaved changes. Are you sure you want to leave?</p>
    <div class="erg-confirm-actions">
      <button type="button" class="btn btn-toyota-outline" (click)="cancelGoBack()">Cancel</button>
      <button type="button" class="btn btn-toyota-primary" (click)="confirmGoBack()">Leave Page</button>
    </div>
  </div>
</div>

<div id="mainForm" *ngIf="!isLoading && chapterList">
  <div class="container py-4">
    <div class="erg-print-only erg-print-header">
      <div class="erg-print-header-left">
        <strong class="erg-print-title">ERG Acknowledgement Form</strong>
        <span class="erg-print-subtitle">FY27 ERG Guidelines &ndash; Acknowledgement &amp; Agreement</span>
      </div>
      <div class="erg-print-header-right">
        <span *ngIf="siteName || bpgName">{{ siteName }} &ndash; {{ bpgName }}</span>
        <span>Status: {{ printStatusLabel }}</span>
        <span *ngIf="printedAt">Printed: {{ printedAt }}</span>
      </div>
    </div>
    <hr class="erg-print-only erg-print-hr">

    <div class="row mb-4 erg-no-print">
      <div class="col-12 d-flex justify-content-between align-items-center erg-page-header">
        <div>
          <h1 class="h4 mt-2 mb-1 color erg-page-title">ERG Acknowledgement Form 
            <span *ngIf="isSuperAdmin" class="pt-2" style="font-size: 13px; padding-left: 10px;">
            <a [routerLink]="['/omnidashboard']" [queryParams]="{ view: 'acknowledgement-status' }" class="pl-0 download-link" style=" color:black; font-weight: 100;font-family: Verdana, Geneva, Tahoma, sans-serif; text-decoration: underline;">
              Overall Status
            </a>
          </span>
          </h1>
          <p class="text-muted mb-0">FY27 ERG Guidelines &ndash; Acknowledgement &amp; Agreement</p>
        </div>
        <div class="d-flex align-items-center erg-no-print erg-header-actions">
          <app-erg-feedback [isAdmin]="isSuperAdmin" [userId]="userId"></app-erg-feedback>
          <button type="button" class="btn btn-toyota-outline" (click)="goBack()">
            <i class="fa fa-arrow-left" aria-hidden="true"></i> Back
          </button>
        </div>
      </div>
    </div>

    <div *ngIf="anySignatureCollected && chapterId" class="erg-submitted-banner"
      [class.erg-banner-partial]="!isFormComplete && !isSubmitted">
      <i class="fa erg-submitted-icon" [class.fa-check-circle]="isFormComplete || isSubmitted"
        [class.fa-clock-o]="!isFormComplete && !isSubmitted"
        [class.erg-submitted-icon-partial]="!isFormComplete && !isSubmitted" aria-hidden="true"></i>
      <div class="erg-banner-content">
        <strong *ngIf="isFormComplete">Form Complete &mdash; All Signatures Collected</strong>
        <strong *ngIf="!isFormComplete && isSubmitted">Your Signature Has Been Recorded</strong>
        <strong *ngIf="!isFormComplete && !isSubmitted">Partially Signed &mdash; Awaiting Remaining Signatures</strong>
        <p class="mb-0" *ngIf="isSubmitted || isFormComplete">Decision: <strong>Accepted</strong>
          &mdash; Last Submitted on {{ submittedDate | date:'MMM d, y h:mm a' }}<span *ngIf="latestSignatoryLabel"> by
            <strong>{{ latestSignatoryLabel }}</strong></span></p>
        <p class="mb-0 erg-banner-pending" *ngIf="!isFormComplete">
          <i class="fa fa-clock-o" aria-hidden="true"></i>
          {{ getSignedCount() }} of {{ signatoryTypes.length }} signatures collected &mdash; awaiting remaining
          signatories.
        </p>
      </div>
      <button *ngIf="isSubmitted || isFormComplete" type="button" class="btn btn-toyota-outline erg-print-btn"
        (click)="printForm()" aria-label="Download form as PDF">
        <i class="fa fa-download" aria-hidden="true"></i> Download/Print
      </button>
    </div>

    <div *ngIf="alertSuccess" class="alert alert-success d-flex align-items-center" role="alert">
      <i class="fa fa-check-circle" aria-hidden="true"></i>
      <span class="erg-alert-text">{{alertMessage}}</span>
      <button type="button" class="erg-alert-dismiss" (click)="dismissAlert()" aria-label="Dismiss">
        <i class="fa fa-times" aria-hidden="true"></i>
      </button>
    </div>
    <div *ngIf="alertError" class="alert alert-danger d-flex align-items-center" role="alert">
      <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
      <span class="erg-alert-text">{{alertMessage}}</span>
      <button type="button" class="erg-alert-dismiss" (click)="dismissAlert()" aria-label="Dismiss">
        <i class="fa fa-times" aria-hidden="true"></i>
      </button>
    </div>

    <div class="card mb-4">
      <div class="card-header d-flex align-items-center">
        <i class="fa fa-info-circle erg-icon-spacing" aria-hidden="true"></i> Chapter Selection
      </div>
      <div class="card-body">
        <div class="mb-3 row align-items-center">
          <label for="selectChapter" class="col-sm-3 col-form-label">Employee Resource Group (ERG) / Chapter</label>
          <div class="col-sm-9">
            <ng-select id="selectChapter" placeholder="-- Select Chapter --" [items]="chapterList"
              bindLabel="chapterName" [(ngModel)]="chapterId" bindValue="chapterId"
              (change)="$event && fetchChapterData($event.chapterId)" [searchable]="true" aria-required="true"
              aria-label="Employee Resource Group (ERG) / Chapter">
            </ng-select>
            <span class="erg-print-only erg-field-value form-control" *ngIf="siteName || bpgName">
              {{ siteName }} &ndash; {{ bpgName }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="card mb-4" *ngIf="chapterId">
      <div class="card-header d-flex align-items-center">
        <i class="fa fa-file-text-o erg-icon-spacing" aria-hidden="true"></i> Purpose
      </div>
      <div class="card-body">
        <p class="mb-0">To formally acknowledge and confirm that you <strong>({{selectedChapter.siteName + ' - ' +
            selectedChapter.bpgName}})</strong> have reviewed and accepted the updated FY27 ERG Guidelines.
          We look forward to continuing success with our Employee Resource Groups (ERGs) and to achieving best-in-class
          standards!</p>
      </div>
    </div>

    <div class="card mb-4" *ngIf="(!isSubmitted && !isFormComplete && chapterId) || printedAt">
      <div class="card-header d-flex align-items-center">
        <i class="fa fa-list-ol erg-icon-spacing" aria-hidden="true"></i> Directions
      </div>
      <div class="card-body">
        <ol class="mb-2 erg-directions-list">
          <li>Please read through the ERG Responsibilities and Governance guidelines below.</li>
          <li>Type your full name in the signature field below to confirm that you understand and agree to these terms.</li>
          <li>If you identify any errors with the Executive Sponsor, Chair, or Vice Chair/Co-Chair fields, please check
            your chapter page &mdash; this form is populated directly from it.</li>
        </ol>
        <div class="erg-deadline-notice mt-2 align-items-center erg-no-print">
          <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
          Failure to complete this form by end of business <strong>June 15, 2026</strong> may risk your chapter
          sunsetting.
        </div>
      </div>
    </div>

    <form #ergtNcForm="ngForm" [class.erg-form-submitted]="isSubmitted">
      <div *ngIf="chapterId">
        <div class="card mb-4">
          <div class="card-header d-flex align-items-center">
            <i class="fa fa-users erg-icon-spacing" aria-hidden="true"></i> Primary Contacts
          </div>
          <div class="card-body">
            <div class="mb-3 row align-items-center">
              <label for="executiveSponsor" class="col-sm-3 col-form-label">Executive Sponsor</label>
              <div class="col-sm-9">
                <span id="executiveSponsor" class="form-control erg-field-value" aria-label="Executive Sponsor">
                  {{ sponsorName }}
                  <span *ngIf="!sponsorName" class="erg-badge-not-assigned">Not Assigned</span>
                </span>
              </div>
            </div>
            <div class="mb-3 row align-items-center">
              <label for="chair" class="col-sm-3 col-form-label">Chair</label>
              <div class="col-sm-9">
                <span id="chair" class="form-control erg-field-value" aria-label="Chair">
                  {{ chairName }}
                  <span *ngIf="!chairName" class="erg-badge-not-assigned">Not Assigned</span>
                </span>
              </div>
            </div>
            <div class="mb-3 row align-items-center">
              <label for="viceChair" class="col-sm-3 col-form-label">Vice Chair or Co-Chair</label>
              <div class="col-sm-9">
                <span id="viceChair" class="form-control erg-field-value" aria-label="Vice Chair or Co-Chair">
                  {{ viceChairName }}
                  <span *ngIf="!viceChairName" class="erg-badge-not-assigned">Not Assigned</span>
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="card mb-4">
          <div class="card-header d-flex align-items-center">
            <i class="fa fa-eye erg-icon-spacing" aria-hidden="true"></i> ERG Vision Statement
          </div>
          <div class="card-body">
            <div class="erg-commitment-card">
              <p class="mb-0">ERGs are strategic drivers that empower <strong>every</strong> Toyota team member by
                fostering engagement, leadership, inclusion, and innovation. Evolving from grassroots communities into
                <strong>impactful, team member-focused networks</strong>, ERGs strengthen connection and growth
                across our One Toyota community.
              </p>
            </div>
          </div>
        </div>

        <div class="card mb-4">
          <div class="card-header d-flex align-items-center">
            <i class="fa fa-list-alt erg-icon-spacing" aria-hidden="true"></i> Responsibilities &amp; Governance
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <h6 class="erg-section-subheader">Responsibilities</h6>
                <ul class="erg-policy-list">
                  <li>
                    Plan and deliver meaningful events that advance team member engagement and innovation through the
                    three annual plan drivers:
                    <ul class="erg-policy-sublist">
                      <li>Team Member Engagement</li>
                      <li>Community Engagement</li>
                      <li>Career Readiness Support</li>
                    </ul>
                  </li>
                  <li>Develop an annual plan and submit it to the NAAC and SDD.</li>
                  <li>Following each event or initiative, complete a reflection to recognize successes and capture
                    improvement opportunities.</li>
                  <li>Maintain your ERG Connect page, including current board members and the executive sponsor.</li>
                </ul>
              </div>
              <div class="col-md-6">
                <h6 class="erg-section-subheader">Governance</h6>
                <ul class="erg-policy-list">
                  <li>1&ndash;2 events per quarter. All events must be included in the annual plan; ad-hoc events will
                    not be approved.</li>
                  <li>Annual plans align to the fiscal year (FY April&ndash;March). Event rollovers are not permitted.
                  </li>
                  <li>Provide a quarterly budget report to Executive Sponsor and SDD.</li>
                  <li>ERGs receive fiscal year funding from SDD and cannot request or accept additional funds from the
                    business or any other source.</li>
                  <li>Each event should have two leads and 2&ndash;3 KPIs.</li>
                  <li>Partner with at least one other ERG for career readiness or community engagement events that
                    include a donation drive.</li>
                  <li>Nonprofits must be listed in T4G. ERGs are strongly encouraged to partner with national community
                    partners.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div class="card mb-4" *ngIf="chapterId">
          <div class="card-header d-flex align-items-center">
            <i class="fa fa-file-text-o erg-icon-spacing" aria-hidden="true"></i>
            ERG Policy Review
          </div>
          <div class="card-body">
            <p class="mb-3">
              Before signing, please review at least one official ERG Policy document below.
              You must review at least one policy before your signature box is unlocked.
            </p>
            <div class="erg-policy-links-row" [class.erg-policy-links-row--tmmc]="isTmmcSite">
              <a href="https://toyotahr.service-now.com/kb?id=kb_article_view&sysparm_article=KB0011750"
                target="_blank" rel="noopener noreferrer"
                class="btn btn-sm erg-policy-btn" [class.erg-policy-btn-done]="hasPolicyReadTMNA"
                (click)="onPolicyLinkClicked('TMNA')"
                [attr.aria-label]="'Review TMNA ERG Policy' + (hasPolicyReadTMNA ? ' (Reviewed)' : '')">
                <i class="fa erg-icon-spacing" [class.fa-check]="hasPolicyReadTMNA"
                  [class.fa-external-link]="!hasPolicyReadTMNA" aria-hidden="true"></i>
                ERG Policy (TMNA)
              </a>
              <a href="https://toyotahr.service-now.com/kb?id=kb_article_view&sysparm_article=KB0011970&sys_kb_id=dab3b085874043d05235eb183cbb354a"
                target="_blank" rel="noopener noreferrer"
                class="btn btn-sm erg-policy-btn" [class.erg-policy-btn-done]="hasPolicyReadTFS"
                (click)="onPolicyLinkClicked('TFS')"
                [attr.aria-label]="'Review TFS ERG Policy' + (hasPolicyReadTFS ? ' (Reviewed)' : '')">
                <i class="fa erg-icon-spacing" [class.fa-check]="hasPolicyReadTFS"
                  [class.fa-external-link]="!hasPolicyReadTFS" aria-hidden="true"></i>
                ERG Policy (TFS)
              </a>
              <div *ngIf="isTmmcSite" class="erg-tmmc-policies">
                <a href="assets/userguides/ERG%20Policy%20-%20TMMC.pdf"
                  target="_blank" rel="noopener noreferrer"
                  class="btn btn-sm erg-policy-btn" [class.erg-policy-btn-done]="hasPolicyReadTmmcPolicy"
                  (click)="onPolicyLinkClicked('tmmcPolicy')"
                  [attr.aria-label]="'Review ERG Policy (TMMC)' + (hasPolicyReadTmmcPolicy ? ' (Reviewed)' : '')">
                  <i class="fa erg-icon-spacing" [class.fa-check]="hasPolicyReadTmmcPolicy"
                    [class.fa-external-link]="!hasPolicyReadTmmcPolicy" aria-hidden="true"></i>
                  ERG Policy (TMMC)
                </a>
                <a href="https://tm.tmmc.ca/download/show/DocumentLibrary/vision_hr/Ethics%20and%20Conflict%20of%20Interest.pdf"
                  target="_blank" rel="noopener noreferrer"
                  class="btn btn-sm erg-policy-btn" [class.erg-policy-btn-done]="hasPolicyReadTmmcEthics"
                  (click)="onPolicyLinkClicked('tmmcEthics')"
                  [attr.aria-label]="'Review Ethics and Conflict of Interest (TMMC)' + (hasPolicyReadTmmcEthics ? ' (Reviewed)' : '')">
                  <i class="fa erg-icon-spacing" [class.fa-check]="hasPolicyReadTmmcEthics"
                    [class.fa-external-link]="!hasPolicyReadTmmcEthics" aria-hidden="true"></i>
                  Ethics and Conflict of Interest (TMMC)
                </a>
                <a href="https://tm.tmmc.ca/download/show/DocumentLibrary/vision_hr/II%20-%2010%20TMMC%20Solicitation%20and%20Distribution%20Policy.pdf"
                  target="_blank" rel="noopener noreferrer"
                  class="btn btn-sm erg-policy-btn" [class.erg-policy-btn-done]="hasPolicyReadTmmcSolicitation"
                  (click)="onPolicyLinkClicked('tmmcSolicitation')"
                  [attr.aria-label]="'Review Solicitation Policy (TMMC)' + (hasPolicyReadTmmcSolicitation ? ' (Reviewed)' : '')">
                  <i class="fa erg-icon-spacing" [class.fa-check]="hasPolicyReadTmmcSolicitation"
                    [class.fa-external-link]="!hasPolicyReadTmmcSolicitation" aria-hidden="true"></i>
                  Solicitation Policy (TMMC)
                </a>
              </div>
            </div>
            <div class="erg-policy-confirmed mt-3" *ngIf="isAnyPolicyRead() && !isSubmitted && canSign">
              <i class="fa fa-check-circle" aria-hidden="true"></i>
              Policy reviewed &mdash; you may now proceed to sign below.
            </div>
          </div>
        </div>

        <div class="card mb-4 erg-interactive-card">
          <div class="card-header d-flex align-items-center justify-content-between">
            <span>
              <i class="fa fa-pencil-square erg-icon-spacing" aria-hidden="true"></i> Digital Signatures
            </span>
            <span class="erg-info-tooltip" tabindex="0" role="button" [attr.aria-label]="getUserSignTooltip()">
              <i class="fa fa-info-circle" aria-hidden="true"></i>
              <span class="erg-tooltip-text" aria-hidden="true">{{ getUserSignTooltip() }}</span>
            </span>
          </div>
          <div class="card-body">

            <div class="erg-consent-notice" *ngIf="canSign">
              <i class="fa fa-info-circle erg-consent-icon" aria-hidden="true"></i>
              <span>By signing below, I acknowledge that I have read and will follow the updated ERG policy, support the
                ERG vision, and comply with ERG expectations and guidelines.</span>
            </div>

            <div class="row" *ngFor="let t of signatoryTypes; trackBy: trackByValue">
              <div class="col-md-12">
                <div class="erg-signature-card"
                  [class.erg-card-readonly]="!userCanSignMap[t]"
                  [class.erg-card-signed]="signatories[t].signed"
                  [class.erg-card-typing]="userCanSignMap[t] && !!signatories[t].data && !signatories[t].signed"
                  [class.erg-card-active]="userCanSignMap[t] && !signatories[t].data && !signatories[t].signed"
                  [attr.aria-label]="signatories[t].label + ' signature block'">
                  <div class="erg-print-only erg-print-sig-header">
                    <span class="erg-print-sig-role">{{signatories[t].label}}</span>
                    <span class="erg-print-sig-name">{{getSignatoryName(t)}}</span>
                    <span class="erg-print-sig-badge">
                      <span class="erg-access-badge erg-badge-signed" *ngIf="signatories[t].signed">Signed</span>
                      <span class="erg-access-badge erg-badge-pending" *ngIf="!signatories[t].signed">Pending</span>
                    </span>
                  </div>
                  <div class="erg-signature-header row align-items-center">
                    <span class="col-md-4 erg-signature-role">{{signatories[t].label}}</span>
                    <span class="col-md-4 erg-signature-name text-center">{{getSignatoryName(t)}}</span>
                    <div class="col-md-4 text-right">
                      <span class="erg-access-badge erg-badge-yours"
                        *ngIf="userCanSignMap[t] && !isSignatureLocked(t)">Your Signature</span>
                      <span class="erg-access-badge erg-badge-signed"
                        *ngIf="(userCanSignMap[t] && isSignatureLocked(t)) || (!userCanSignMap[t] && signatories[t].signed)">Signed</span>
                      <span class="erg-access-badge erg-badge-pending"
                        *ngIf="!userCanSignMap[t] && !signatories[t].signed">Pending</span>
                    </div>
                  </div>
                  <div class="erg-signed-date" *ngIf="signatories[t].signed && signatories[t].date">
                    Signed on {{signatories[t].date | date:'MMM d, y h:mm a'}}
                  </div>
                  <div class="erg-canvas-wrapper"
                    [class.erg-canvas-disabled]="!userCanSignMap[t] && !signatories[t].data"
                    [class.erg-canvas-locked]="!userCanSignMap[t] || isSignatureLocked(t) || !isAnyPolicyRead()">
                    <div class="erg-print-only erg-print-awaiting" *ngIf="!signatories[t].signed">
                      &mdash;&nbsp;Awaiting Signature&nbsp;&mdash;
                    </div>
                    <span class="erg-print-only erg-print-sig-text" *ngIf="signatories[t].signed && signatories[t].data">{{signatories[t].data}}</span>
                    <div class="erg-sig-field-wrapper erg-no-print">
                      <input
                        type="text"
                        class="erg-sig-input"
                        [value]="signatories[t].data || ''"
                        (input)="onSigInput(t, $event)"
                        [disabled]="!userCanSignMap[t] || isSignatureLocked(t) || !isAnyPolicyRead()"
                        [placeholder]="getSignaturePlaceholder(t)"
                        [attr.aria-label]="signatories[t].label + ' – type your full name here'"
                        autocomplete="off"
                        spellcheck="false"
                      />
                    </div>
                    <button type="button" class="erg-clear-btn" (click)="clearSignature(t)"
                      *ngIf="userCanSignMap[t] && !!signatories[t].data && !isSignatureLocked(t)">
                      <i class="fa fa-eraser" aria-hidden="true"></i> Clear
                    </button>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        <div class="erg-footer-spacer"></div>
      </div>
    </form>

    <div class="erg-print-only erg-print-footer">
      <span>Internal Use Only</span>
      <span>ERG Acknowledgement Form &mdash; FY27</span>
      <span *ngIf="printedAt">Printed: {{ printedAt }}</span>
    </div>
  </div>

  <div class="erg-sticky-footer" *ngIf="chapterId && !isSubmitted && canSign">
    <div class="container d-flex justify-content-between align-items-center">

      <small class="text-muted" *ngIf="!hasAnyUserSignature && !isAnyPolicyRead()">
        <i class="fa fa-lock erg-icon-spacing" aria-hidden="true"></i>
        Review a policy link above to unlock signing.
      </small>
      <small class="text-muted" *ngIf="!hasAnyUserSignature && isAnyPolicyRead()">
        Sign in the panel above to proceed.
      </small>

      <small class="text-muted" *ngIf="hasAnyUserSignature">
        <i class="fa fa-pencil-square erg-icon-spacing" aria-hidden="true"></i>
        <span *ngIf="userHasSigned">Your signature: <strong class="color">Recorded</strong> &middot; </span>
        Overall: <strong class="color">{{ getSignedCount() }}</strong> of {{ signatoryTypes.length }} collected
      </small>

      <button type="button" class="btn btn-toyota-primary"
        [disabled]="isSubmitting || !hasAnyUserSignature || !isAnyPolicyRead()" (click)="submitTnC()"
        aria-label="Submit">
        <ng-container *ngIf="!isSubmitting">
          <i class="fa fa-paper-plane erg-submit-icon" aria-hidden="true"></i>
          Submit
        </ng-container>
        <ng-container *ngIf="isSubmitting">
          <i class="fa fa-spinner fa-spin" aria-hidden="true"></i> Submitting...
        </ng-container>
      </button>

    </div>
  </div>
</div>